 import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./login.css";

const Login = () => {
  const navigate = useNavigate();

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSuccessMsg("");
    setErrorMsg("");

    try {
      const response = await axios.post(
        "/api/auth/login",
        loginData
      );

      // Check backend response
      console.log(response.data);

      // Save JWT Token
      localStorage.setItem("token", response.data.token);

      // Save User Data
      localStorage.setItem(
        "user",
        JSON.stringify(response.data.user)
      );

      setSuccessMsg("Login successful! Redirecting...");

      setLoginData({
        email: "",
        password: "",
      });

      setTimeout(() => {
        navigate("/");
      }, 1000);

    } catch (error) {
      setErrorMsg(
        error.response?.data?.message || "Login failed"
      );
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">

        <h2>EcoVibe Login</h2>

        {successMsg && (
          <p className="success-message">{successMsg}</p>
        )}

        {errorMsg && (
          <p className="error-message">{errorMsg}</p>
        )}

        <form onSubmit={handleSubmit}>

          <label>Email</label>

          <input
            type="email"
            name="email"
            value={loginData.email}
            onChange={handleChange}
            placeholder="you@example.com"
            required
          />

          <label>Password</label>

          <input
            type="password"
            name="password"
            value={loginData.password}
            onChange={handleChange}
            placeholder="Password"
            required
          />

          <button type="submit">
            Login
          </button>

        </form>

        <span className="forgot-link">
          <a href="/forgot-password">
            Forgot Password?
          </a>
        </span>

        <p className="signup-link">
          Don't have an account?
          <a href="/signup">
            Signup
          </a>
        </p>

      </div>
    </div>
  );
};

export default Login;